import constants from "../../../../constants/constants.json";
import { createTreatmentComponent } from "./createTreatmentComponent";
import { useCompression, usePrimaryDressing, useSkinProtectant, useWoundCleanser } from "./hooks/TreatmentHooks";

export const SkinProtectant = createTreatmentComponent(useSkinProtectant, constants.assessment.noSkinProtectant);

export const WoundCleanser = createTreatmentComponent(useWoundCleanser, constants.assessment.noWoundCleanser);

export const PrimaryDressing = createTreatmentComponent(usePrimaryDressing, constants.assessment.noPrimaryDressing);

export const Compression = createTreatmentComponent(useCompression, constants.assessment.noCompression);
